/**
 * Formats an address for display by removing country if it's USA
 * and cleaning up formatting
 */
export function formatAddressForDisplay(address: string): string {
  if (!address) return '';
  
  // Remove ", USA" from the end if present
  let formatted = address.replace(/,\s*USA\s*$/i, '');
  
  // Also remove "United States" variations
  formatted = formatted.replace(/,\s*(United States|United States of America)\s*$/i, '');
  
  // Clean up any double commas or trailing commas
  formatted = formatted.replace(/,\s*,/g, ',').replace(/,\s*$/, '');
  
  return formatted.trim();
}

/**
 * Truncates an address to show only the most important parts
 * Prioritizes street and city over state/country
 */
export function truncateAddress(address: string, maxLength: number = 50): string {
  const formatted = formatAddressForDisplay(address);
  
  if (formatted.length <= maxLength) {
    return formatted;
  }
  
  // Try to intelligently truncate by keeping street and city
  const parts = formatted.split(',').map(p => p.trim());
  
  if (parts.length >= 2) {
    // Keep first two parts (usually street and city)
    const shortened = parts.slice(0, 2).join(', ');
    if (shortened.length <= maxLength) {
      return shortened + '...';
    }
  }
  
  // If still too long, just truncate with ellipsis
  return formatted.substring(0, maxLength - 3) + '...';
}